import styled, { createGlobalStyle, css } from 'styled-components';

// Thanks
export const FormThanks = styled.div`
  text-align: center;
`;

// Fast Action Sign Up Modal
export const GlobalFastActionSignUpModalStyles = createGlobalStyle`
  html.has-overlay {
    overflow-y: auto !important;
  }
  #fastaction-signup {
    display: none !important;
  }
`;

export const Wrapper = styled.div<{
  maxWidth?: number;
  padded?: boolean;
}>`
  font-weight: 700;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}px` : 'none')};
  margin: 0 auto;
  margin-top: -0.75rem;
  margin-bottom: 2.25rem;
  ${props =>
    props.padded &&
    css`
      padding-left: var(--form-side-padding);
      padding-right: var(--form-side-padding);
    `}
  
  .Select-menu {
    overflow: scroll !important;
  }
  
  #double-donation-header {
    font-family: var(--font-tertiary);
    font-size: 1.5rem;
    margin-bottom: 1rem;
  }
  
  #double-donation-lede {
    margin-bottom: 1.5rem;  
    font-size: 1.1rem;
    font-weight: 800;
  }

  #double-donation-link {
    font-family: var(--font-tertiary);
    font-weight: 300;
    color: var(--color-neutral-600) !important;
    text-decoration: none;
    border-bottom: 2px solid var(--color-primary-300);
    background-color 0.2s ease-in-out;
    margin-top: -1rem;

    &:hover {
      background-color: var(--color-primary-300) !important;
    }
  }
`;
